enum ReadOnlyEmptyStates {
  NoSoftwareApplicationsSelected = "No software applications selected",
  NoLabelsSelected = "No labels selected",
  NoAssociatedFlows = "No associated Flows",
  NoTriggerSelected = "No trigger selected",
  NoFlowSelected = "No Flow selected",
  NoPreviewText = "No preview text",
  NoEndNoteTextProvided = "No end note text provided",
  NoThumbnailImageUploaded = "No thumbnail image uploaded",
  None = "None",
  NoLinksAvailable = "No links available",
}

export default ReadOnlyEmptyStates;
